import * as React from 'react'
import routes from './_routes'
import { ReactQueryProvider } from './providers/ReactQueryProvider'
import AccountStore from './stores/Account'
import theme from './theme'
import NiceModal from '@ebay/nice-modal-react'
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { observer } from 'mobx-react'
import { Col, Row } from 'react-flexbox-grid'
import { BrowserRouter as Router } from 'react-router-dom'
import { CompatRouter } from 'react-router-dom-v5-compat'
import { LastLocationProvider } from 'react-router-last-location'

import RouteHandler from './components/RouteHandler'
import ScrollToTop from './components/ScrollWindowToTop'

import insiteLogo from 'images/logo/insite_logo_full.svg'

import './style.scss'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

const gtmParams = { id: import.meta.env.VITE_TAG_MANAGER_KEY || '' }

export interface AppState {}

class App extends React.Component<{}, AppState> {
  constructor(args: any) {
    super(args)
  }

  componentDidMount() {
    AccountStore.getProfile()
  }

  componentDidUpdate() {
    if (!AccountStore.retrieved) {
      AccountStore.getProfile()
    }
  }

  render() {
    return (
      <GTMProvider state={gtmParams}>
        {/* @ts-ignore - React Router v5 types incompatible with TS 5.0 */}
        <Router>
          <CompatRouter>
            <LastLocationProvider>
              <ScrollToTop>
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={theme}>
                    <ReactQueryProvider>
                      <NiceModal.Provider>
                        {AccountStore.retrieved ? (
                          <RouteHandler isLoggedIn={AccountStore.isLoggedIn} routes={routes} />
                        ) : (
                          <Row className="title-screen">
                            <Col xs={12}>
                              <Row middle="xs" center="sm" className="inner">
                                <Col md={4} lg={3} xs={12}>
                                  <img
                                    src={insiteLogo}
                                    className="komatsu-logo"
                                    alt="Komatsu logo"
                                    width="100%"
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        )}
                      </NiceModal.Provider>
                    </ReactQueryProvider>
                  </ThemeProvider>
                </StyledEngineProvider>
              </ScrollToTop>
            </LastLocationProvider>
          </CompatRouter>
        </Router>
      </GTMProvider>
    )
  }
}

export default observer(App)
